export default __webpack_public_path__ + "static/media/CH-alain.62a86b48.jpg";